module.exports = __webpack_public_path__ + "static/media/6.b9da55e3.png";